@import '~style-sheet-helpers/core.less';

.modal-body {
  padding: 20px;
  max-width: 600px;

  .info-icon-and-label {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .description {
    font-size: 14px;
    line-height: 20px;
  }

  .passwordInputs {
    max-width: 400px;
    display: flex;
    justify-content: center;
    align-items: center;

    .password {
      margin: 20px 0;
    }
  }
}

.error-banner {
  margin-bottom: 10px;
}

.checkbox {
  margin-top: 5px;
}
